<img [attr.src]="storefront?.logoUrl" [attr.alt]="storefront?.name" class="brand-logo" />
